<script lang="ts">
    import Breakpoints from "@ui-utils/ContainerQuery/Breakpoints.svelte";
    import CN from "classnames";
</script>

<Breakpoints let:mdUp>
    <li
        class={CN("gw-rv-item", {
            "gw-rv-item--small": !mdUp,
        })}
    >
        <div class="gw-rv-item__body">
            <div class="gw-rv-item__author">
                <slot name="author" />
                <slot name="meta" />
            </div>

            <div class="gw-rv-item__customer-attributes">
                <slot name="customer-attributes" />
            </div>

            <div class="gw-rv-item__rating">
                <slot name="rating" />
            </div>

            <div class="gw-rv-item__published">
                <slot name="published" />
            </div>

            <div class="gw-rv-item__content">
                <div class="gw-rv-item__content-header" />
                <slot name="title" />

                <slot name="text" />

                <div class="gw-rv-item__translation">
                    <slot name="see-translation-btn" />
                </div>

                <slot name="images" />

                <slot name="product-attributes" />

                <div class="gw-rv-item__bottom">
                    <slot name="vote" /><slot name="date" />
                </div>

                <slot name="reply" />
            </div>
            <div class="gw-rv-item__footer">
                <slot name="footer" />
            </div>
        </div>
    </li>
</Breakpoints>

<style lang="postcss">
    .gw-rv-item {
        &__body {
            display: grid;
            grid-template-columns: 13.125em 1fr;

            padding: 1em 0.75em;
            border-radius: 6px;
            box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
        }

        &--small &__body {
            grid-template-columns: 1fr;
            grid-template-rows: 4fr;
        }

        &:last-child {
            border-bottom: none;
        }

        &__author {
            grid-column: 1 / 2;

            display: flex;
            flex-direction: column;
        }

        &--small &__author {
            grid-column: 1 / 3;
            grid-row: 3 / 4;

            flex-direction: row;
            column-gap: 0.5em;
            flex-wrap: wrap;
            padding-top: 0.5em;
        }

        &__customer-attributes {
            grid-column: 1 / 2;
            grid-row: 4 / 5;
        }

        &--small &__customer-attributes {
            grid-row: 4 / 5;
        }

        &__translation {
            display: flex;
            align-items: center;
            justify-self: end;
        }

        &__translation:empty {
            display: none;
        }

        &--small &__translation {
            font-size: 0.7em;
        }

        &__rating {
            grid-column: 2 / 3;
            grid-row: 1 / 2;

            display: flex;
            align-items: baseline;
        }

        &--small &__rating {
            grid-column: 1 / 2;
            grid-row: 1 / 2;
            font-size: 0.7em;
        }

        &__published {
            grid-column: 2 / 3;
            grid-row: 1 / 2;
            justify-self: end;
        }

        &--small &__published {
            grid-column: 2 / 3;
            grid-row: 1 / 2;
            justify-self: end;
        }

        &__content {
            display: flex;
            flex-direction: column;
            flex: 2;
            gap: 0.5em;
            grid-row: 4 / 5;
            grid-column: 2 / 3;
        }

        &--small &__content {
            grid-row: 6 / 7;
            grid-column: 1 / 3;
        }

        &__content-header {
            display: flex;
            justify-content: space-between;
        }

        &__bottom {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 1em;
        }

        &__footer {
            grid-row: 5 / 6;
            grid-column: 1 / 3;
        }
    }
</style>
